import { CircleChevronDownIcon, CircleChevronUpIcon } from 'lucide-react';

import './expand-toggle.scss';

type ExpandToggleProps = {
  isExpanded: boolean;
  onToggle: () => void;
  className?: string;
};

export function ExpandToggle({
  isExpanded,
  onToggle,
  className = '',
}: ExpandToggleProps) {
  const Icon = isExpanded ? CircleChevronUpIcon : CircleChevronDownIcon;

  return (
    <button
      type="button"
      className={`expand-toggle ${className}`}
      onClick={onToggle}
      aria-label={isExpanded ? 'Collapse' : 'Expand'}
      title={isExpanded ? 'Collapse' : 'Expand'}
    >
      <Icon size={42} strokeWidth={1} className="expand-toggle-icon" />
    </button>
  );
}
